<template>
  <v-form>
    <v-card width="500" class="mx-auto mt-9" :loading="isLoading">
      <template slot="progress">
        <v-progress-linear height="10" indeterminate></v-progress-linear>
      </template>
      <v-card-title>Connexion</v-card-title>
      <v-card-text>
        <span v-if="error" class="error--text"
          >Une erreur inattendue s'est produite lors de votre connexion.
        </span>
        <span v-if="failed" class="error--text"
          >Identité ou mot de passe invalide.
        </span>

        <v-text-field
          label="Identité"
          v-model="username"
          prepend-icon="mdi-account-circle"
        ></v-text-field>

        <password-field v-model="password"></password-field>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn
          type="submit"
          color="produit"
          text
          class="mx-auto"
          @click.prevent="login"
          :disabled="isLoading"
        >
          <v-icon>mdi-login</v-icon> Me connecter</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import AuthenticateService from "@/services/AuthenticateService";
import PasswordField from "@/components/PasswordField.vue";

export default {
  name: "LoginForm",
  components: {
    PasswordField,
  },
  data() {
    return {
      showPassword: false,
      username: "",
      password: "",
      failed: false,
      error: false,
      isLoading: false,
    };
  },
  methods: {
    login() {
      // console.log("in");
      if (this.isLoading) return;
      this.isLoading = true;
      this.error = false;
      this.failed = false;
      AuthenticateService.authenticate(this.username, this.password)
        .then((res) => {
          let infos = res.data;
          this.$store.dispatch("setIndentityInfos", infos);
          // redirection vers menu
          this.$router.push({ name: "menu" });
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status == 401 || err.response.status == 404) {
            this.failed = true;
            this.error = false;
          } else {
            this.failed = false;
            this.error = true;
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
<style scoped></style>
